import React from 'react'
import {GoMarkGithub} from 'react-icons/go'
import {AiFillLinkedin} from 'react-icons/ai'
import {MdOutgoingMail} from 'react-icons/md'
import { IconContext } from "react-icons";
import { useMediaQuery } from 'react-responsive'
import {useRef} from 'react';



const phoneViewNav = {
  size: '1em',
  
  }
  
  const DesktopViewNav = {
      size: '1.5em',
  }

export const HeaderSocial = () => {

  const windowWidth = useRef(window.innerWidth);
  const windowHeight = useRef(window.innerHeight);

  console.log('width: ', windowWidth.current);
  console.log('height: ', windowWidth.current);

    const isDesktopOrLaptop = useMediaQuery({maxWidth:830})
    const iconSize = isDesktopOrLaptop ? 20 : 60

  return (
    <div className="header_socials socials_mobile">
        <IconContext.Provider value={{ className: "icon", size: iconSize }}>
  <>
  <a href="https://github.com/mehari123" target="_blank" className="icon" ><AiFillLinkedin /> </a>
        <a href="www.linkedin.com/in/meharitesfaye-4444a2219"target="_blank" className="icon" ><GoMarkGithub /> </a>
        <a href="meharithegreat@gmail.com" target="_blank" ><MdOutgoingMail /></a>
        <a href="#" target="_blank" ></a>
  </>
</IconContext.Provider>
       
    </div>
  )
}
